import { CrossFunctionalMetrics } from "./CrossFunctionalMetrics";

export default CrossFunctionalMetrics;
